import { put } from "redux-saga/effects";
import {
  HANDLE_INCOMING_CALL,
  HANDLE_INCOMING_CALL_SUCCESS,
  HANDLE_INCOMING_CALL_REJECTED,
} from "../../CONSTANTS";
import Client, {
  getClientId,
  getClientDataRecord,
  CLIENT_TYPES,
} from "../../schema/Client";

export default function* handleIncomingCall({ action, config }) {
  try {
    yield put({
      type: HANDLE_INCOMING_CALL,
      payload: {
        callId: action.payload.callId,
      },
    });

    const { gqlclient } = config;
    const { data } = yield gqlclient.query({
      query: config.queries.searchClients.query,
      errorPolicy: "ignore",
      fetchPolicy: "network-only",
      variables: {
        search: action.payload.clientPhone,
        searchBy: "PHONE",
        searchPersons: true,
        searchCompanies: false,
      },
    });

    if (data.errors) {
      throw new Error(`gqlerrors ${data.errors}`);
    }

    if (data.clients) {
      const clients = data.clients.map((client) => {
        const type = CLIENT_TYPES.PERSON;
        const Data = getClientDataRecord({ type });
        return new Client({
          id: getClientId({
            remoteId: client.clientId,
            type,
          }),
          remoteId: client.clientId,
          type,
          fromCall: true,
          data: new Data(client),
        });
      });
      yield put({
        type: HANDLE_INCOMING_CALL_SUCCESS,
        payload: {
          callId: action.payload.callId,
          clients,
        },
      });
    } else {
      throw new Error(`no clients object in response`);
    }
  } catch (err) {
    yield put({
      type: HANDLE_INCOMING_CALL_REJECTED,
      payload: { callId: action.payload.callId, error: err },
    });
  }
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/oktell/handleIncomingCall.js